module.exports = __webpack_public_path__ + "static/media/cross.09e8c96d.svg";